import { Models } from "@/api/types";
import { useStripePublishableKey } from "./useStripePublishableKey/useStripePublishableKey";
import { useWalletAvailability } from "./useWalletAvailability";

export function WalletAvailabilityWarmup({ platform }: { platform: Models<"PlatformModel"> }) {
  const key = useStripePublishableKey();
  useWalletAvailability(key, platform);
  return null;
}
